<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">CİHAZ MODELLERİ</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Ayarlar</li>
            <li class="breadcrumb-item active">Cihaz Modelleri</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="deviceModels$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['deviceModelCode','deviceModelName','brand']" [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <button pButton type="button" class="p-button-info" label="Yeni"
                    routerLink="/device-model-add"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="deviceModelCode" [width]="'30%'">Cihaz Modeli Kodu<p-sortIcon
                            field="deviceModelCode"></p-sortIcon>
                    </th>
                    <th pSortableColumn="deviceModelName" [width]="'30%'">Cihaz Modeli Adı
                        <p-sortIcon field="deviceModelName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="brand" [width]="'30%'">Marka
                        <p-sortIcon field="brand"></p-sortIcon>
                    </th>
                    <th [width]="'10%'">

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-deviceModels>
                <tr>
                    <td>{{deviceModels.deviceModelCode}}</td>
                    <td>{{deviceModels.deviceModelName}}</td>
                    <td>{{deviceModels.brand}}</td>
                    <td>
                        <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-success" pTooltip="Güncelle" tooltipPosition="bottom"
                            routerLink="/device-model-update/{{deviceModels.id}}"></button>
                        <button pButton pRipple type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger" pTooltip="Sil" tooltipPosition="bottom"
                            (click)="showDeleteModal(deviceModels.id)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog header="CİHAZ MODELİ SİL" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Cihaz modeli silinecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-dark"></p-button>
        <p-button (click)="deleteDeviceModel()" label="Sil" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>